import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import LoadingProvider from './app/providers/LoadingProvider';
import { Provider } from "react-redux";
import store from './store'
import {ConfigProvider} from "antd";
import './index.css'
import './shared/styles/responsive.css'
import viVN from 'antd/locale/vi_VN'
import theme from './app/theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider locale={viVN} theme={theme}>
        <LoadingProvider>
            <Provider store={store}>
                <App />
            </Provider>
        </LoadingProvider>
    </ConfigProvider>
);
